/**
 * Хранилище того же кабинета, что и в `ExecutiveReport/mocks.ts`.
 *
 * Июнь совпадает с открытым отчётом: балл 34, риск 88 тысяч. Дальше вглубь
 * список показывает, как кабинет к этому пришёл, — иначе дельта в свежей
 * строке не с чем сравнивать.
 *
 * Верхняя запись — июль, ещё не собранный: место следующего отчёта видно
 * до того, как он появится.
 *
 * @format
 */

import type {ReportsArchiveData} from './types';

export const MOCK_ARCHIVE: ReportsArchiveData = {
  companyName: 'Мебельная фабрика «Ольха»',
  adSystem: 'Яндекс Директ',
  entries: [
    {
      id: '2026-07',
      periodFrom: '2026-07-01',
      periodTo: '2026-07-31',
      status: 'scheduled',
      date: '2026-08-01',
      note: 'Отчёт соберётся 1 августа, когда закроется месяц.',
    },
    {
      id: '2026-06',
      periodFrom: '2026-06-01',
      periodTo: '2026-06-30',
      status: 'ready',
      date: '2026-07-01',
      score: 34,
      scorePrev: 41,
      atRisk: 88_400,
      spend: 664_000,
      unread: true,
      headline:
        'Клиент обошёлся в 4 100 ₽ при плане 3 000 ₽, а три недели мая кабинет никто не открывал.',
    },
    {
      id: '2026-05',
      periodFrom: '2026-05-01',
      periodTo: '2026-05-31',
      status: 'ready',
      date: '2026-06-01',
      score: 41,
      scorePrev: 39,
      atRisk: 51_200,
      spend: 640_000,
    },
    {
      id: '2026-04',
      periodFrom: '2026-04-01',
      periodTo: '2026-04-30',
      status: 'ready',
      date: '2026-05-01',
      score: 39,
      scorePrev: 46,
      atRisk: 63_900,
      spend: 581_000,
    },
    {
      id: '2026-03',
      periodFrom: '2026-03-01',
      periodTo: '2026-03-31',
      status: 'ready',
      date: '2026-04-01',
      score: 46,
      atRisk: 24_700,
      spend: 617_000,
    },
    {
      id: '2026-02',
      periodFrom: '2026-02-01',
      periodTo: '2026-02-28',
      status: 'failed',
      date: '2026-03-01',
      note: 'Доступ к Директу был отозван 12 февраля — данных за месяц нет.',
    },
  ],
};

/** Хранилище, в котором ещё ничего нет: первый отчёт собирается прямо сейчас. */
export const MOCK_ARCHIVE_FIRST_RUN: ReportsArchiveData = {
  companyName: MOCK_ARCHIVE.companyName,
  adSystem: MOCK_ARCHIVE.adSystem,
  entries: [
    {
      id: '2026-06',
      periodFrom: '2026-06-01',
      periodTo: '2026-06-30',
      status: 'building',
      date: '2026-07-01',
      note: 'Собираем первый отчёт: система разбирает историю изменений за месяц. Обычно занимает около часа.',
    },
  ],
};

/** Совсем пустое хранилище — кабинет подключён, первый месяц ещё не закрыт. */
export const MOCK_ARCHIVE_EMPTY: ReportsArchiveData = {
  companyName: MOCK_ARCHIVE.companyName,
  adSystem: MOCK_ARCHIVE.adSystem,
  entries: [],
};
